import { SortTypes, Sorting } from "./types"

export const selectSorting = (
  sortBy: string,
  currentSortBy: string,
  currentOrder: SortTypes
): Sorting => {
  if (sortBy === currentSortBy) {
    return {
      sortBy: currentSortBy,
      order: currentOrder === SortTypes.asc ? SortTypes.desc : SortTypes.asc
    }
  }

  return { sortBy, order: SortTypes.asc }
}

export const defaultSorter =
  (sortBy: string, order: SortTypes) => (item1: any, item2: any) => {
    if (!sortBy || !order) return 0

    const [source, target] =
      order === SortTypes.asc ? [item1, item2] : [item2, item1]
    const sourceProp = source?.[sortBy]
    const targetProp = target?.[sortBy]

    // If one of items is number, compare like numbers.
    if (typeof sourceProp === "number" || typeof targetProp === "number") {
      const sourceNumber = sourceProp ?? -Infinity
      const targetNumber = targetProp ?? -Infinity
      return sourceNumber - targetNumber
    }

    // Cast others to strings.
    const sourceStr = sourceProp?.toString() ?? ""
    const targetStr = targetProp?.toString() ?? ""
    return sourceStr.localeCompare(targetStr)
  }

export const getSortIconName = (
  sortBy: string,
  order: SortTypes,
  sortId: string
): string => {
  if (sortBy === sortId && order === SortTypes.desc) return "sort-down"
  if (sortBy === sortId && order === SortTypes.asc) return "sort-up"
  return "sort"
}
